/**
 * EqualWeb Accessibility - Carga diferida tras load de la página (mejora velocidad).
 * Config: https://login.equalweb.com/custom-button
 */
window.interdeal = {
  get sitekey() { return "5fe753fb08bcd46d5ae5aea4cc9bf33e"; },
  get domains() {
    return {
      js: "https://cdn.equalweb.com/",
      acc: "https://access.equalweb.com/"
    };
  },
  Position: "right",
  Menulang: "EN",
  draggable: true,
  btnStyle: {
    vPosition: ["92%", "85%"],
    margin: ["0", "8px"],
    scale: ["0.6", "0.5"],
    color: {
      main: "#112250",
      second: "#ffffff"
    },
    icon: {
      outline: true,
      outlineColor: "#112250",
      type: 1,
      shape: "circle"
    }
  }
};

(function(doc, head, body) {
  function loadAccessibilityScript() {
    var coreCall = doc.createElement("script");
    coreCall.src = window.interdeal.domains.js + "core/5.2.0/accessibility.js";
    coreCall.defer = true;
    coreCall.async = true;
    coreCall.integrity = "sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ==";
    coreCall.crossOrigin = "anonymous";
    coreCall.setAttribute("data-cfasync", true);
    (body || head).appendChild(coreCall);
  }
  if (document.readyState === "complete") {
    loadAccessibilityScript();
  } else {
    window.addEventListener("load", loadAccessibilityScript, { once: true });
  }
})(document, document.head, document.body);
